<template>
  <div class="flex flex-col gap-4">

    <!-- Table header bar skeleton -->
    <div class="w-full flex flex-col gap-[2px] rounded-lg overflow-hidden">
      <div class="bg-gray-900 text-xs uppercase flex items-center px-4 py-2 h-16">
        <div class="h-3 w-24 bg-gray-800 rounded animate-pulse" />
        <div class="flex-1" />
      </div>

      <!-- Rows skeleton -->
      <div v-for="i in rows" :key="i" class="bg-gray-900">
        <MatchRowSkeleton />
      </div>
    </div>
  </div>
</template>

<script setup>
import MatchRowSkeleton from '../MatchRow/MatchRowSkeleton.vue';

const props = defineProps({
  rows: {
    type: Number,
    default: 5,
  },
});
</script>
